import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="border-top mt-5" style={{ backgroundColor: "#fbfbfb" }}>
      <div className="container py-5">
        <div className="row">
          {/* Logo & Social */}
          <div className="col-12 col-md-3 mb-4">
            <img
              src="media/images/IFTlogo.png"
              alt="logo"
              style={{ maxWidth: "120px", height: "auto" }}
            />
            <p className="mt-3">
              &copy; 2022 - 2025,
              <br /> IT Future Tech
              <br /> All rights reserved.
            </p>
            <div className="social-icons d-flex gap-1 fs-4">
              <a
                href="https://www.linkedin.com/company/itfuturetech/?originalSubdomain=in"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-linkedin-square" aria-hidden="true"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-facebook-official" aria-hidden="true"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-twitter-square" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          {/* About */}
          <div className="col-12 col-md-3 mb-4">
            <p className="fs-5 fw-semibold">About</p>
            <p style={{ textAlign: "justify" }}>
              At IT Future Tech (IFT), our mission is to empower organizations
              through strategic IT recruitment and smart technology solutions.
              We build the tech teams and systems that help businesses move
              faster, smarter, and stronger.
            </p>
          </div>
          <div className="col-12 col-md-1 mb-4"></div>

          {/* Services */}
          <div className="col-12 col-md-2 mb-4">
            <p className="fs-5 fw-semibold">Services</p>
            <Link
              to="/services#itresourcing"
              style={{ textDecoration: "none", color: "black" }}
            >
              IT Resources
            </Link>

            <br />
            <Link
              to="/services#itconsulting"
              style={{ textDecoration: "none", color: "black" }}
            >
              IT Consulting
            </Link>

            <br />
            <Link
              to="/services#itservices"
              style={{ textDecoration: "none", color: "black" }}
            >
              IT Services
            </Link>

            <br />
          </div>

          {/* Contact */}
          <div className="col-12 col-md-3 mb-4">
            <p className="fs-5 fw-semibold">Contact</p>
            <p>
              IT FUTURE TECH
              <br />
              <i
                className="fa fa-envelope"
                style={{ color: "rgb(12, 12, 117)" }}
              ></i>
              <a
                href="mailto:hr@itfuturetech.com"
                style={{
                  textDecoration: "none",
                  color: "black",
                  marginLeft: "5px",
                }}
              >
                hr@itfuturetech.com
              </a>
              <br />
              <i
                className="fa fa-phone-square"
                style={{ color: "rgb(12, 12, 117)" }}
              ></i>
              <a
                href="tel:+919356648891"
                style={{
                  textDecoration: "none",
                  color: "black",
                  marginLeft: "5px",
                }}
              >
                +91 9356648891
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
export default Footer;
